"use strict";
exports.__esModule = true;
exports.EntityViewDocument = void 0;
var EntityViewDocument = /** @class */ (function () {
    function EntityViewDocument(org_id, entity_type, fields, disabled_fields) {
        if (fields === void 0) { fields = []; }
        if (disabled_fields === void 0) { disabled_fields = []; }
        this.org_id = org_id;
        this.entity_type = entity_type;
        this.fields = fields;
        this.disabled_fields = disabled_fields;
    }
    EntityViewDocument.fromJSON = function (json) {
        var view = new EntityViewDocument('', null, [], []);
        if (json) {
            view.org_id = json.org_id ? json.org_id : '';
            view.entity_type = json.entity_type ? json.entity_type : null;
            view.fields = json.fields ? json.fields : [];
            view.disabled_fields = json.disabled_fields ? json.disabled_fields : [];
        }
        return view;
    };
    return EntityViewDocument;
}());
exports.EntityViewDocument = EntityViewDocument;
